module.exports = __webpack_public_path__ + "img/integral.ada4f2f5.png";